
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/industry/[id]",
      function () {
        return require("private-next-pages/company/industry/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/industry/[id]"])
      });
    }
  